import { useQuery } from '@tanstack/react-query';
import { donations } from 'src/backend';

export default function useGetDonationActivityLogs({
  donationId,
  rescueId,
  excludeDonationActivities = false,
  ...options
}) {
  return useQuery({
    queryKey: [
      'donation-activity-logs',
      donationId,
      rescueId,
      excludeDonationActivities,
    ],
    queryFn: () =>
      donations.getDonationEventLogs({
        donationId,
        rescueId,
        excludeDonationActivities,
      }),
    refetchOnWindowFocus: false,
    ...(options ? { ...options } : {}),
  });
}
